<div class="fullcontainer">
  @if (this.isError) {
    <div class="alert alert-danger">Please complete all required fields</div>
  }
  @if (this.isServerError) {
    <div class="alert alert-danger">Something went wrong. Please try again later.</div>
  }
  @if (this.isSuccess) {
    <div class="alert alert-success">User was updated successfully</div>
  }
  <div class='sheet'>
    <h1 class='header'>Edit User - {{ this.user.firstName }} {{ this.user.lastName }}</h1>
    <app-audit-line [data]='this.user'></app-audit-line>
    <form (ngSubmit)='this.onSubmit()' method='post'>
      <app-user-form [userSkills]='this.skills' [user]='this.user'></app-user-form>
      <button type="submit" class="btn btn-success">Save</button>&nbsp;
      <button type="button" class="btn btn-danger" routerLink='/settings/user'>Cancel</button>
    </form>
  </div>
</div>
